<template>
  <v-container py-0>
    <v-card class="fill-height">
      <v-container>
        <v-list-item one-line>
          <v-list-item-content>
            <v-list-item-title
              class="headline"
            >
              Les questions
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-row>
          <v-col cols="11">
            <v-data-table
              :headers="headers"
              :items="questions"
              disable-filtering
              disable-pagination
              disable-sort
              single-select
              hide-default-footer
              show-select
              class="elevation-1"
              @item-selected="selected"
              @click:row="handleClick"
            />
          </v-col>
          <v-col cols="1">
            <v-row>
              <v-btn
                color="primary"
                :disabled="hasUp"
                small
                my-2
                @click="up"
              >
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
            </v-row>
            <v-row>
              <v-btn
                color="primary"
                :disabled="hasDown"
                small
                class="mt-2"
                @click="down"
              >
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-row
              justify="center"
              align="center"
            >
              <v-btn
                color="primary"
                dark
                class="mb-2"
                rounded
                @click="newQuestion"
              >
                Ajouter une question
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: {
    questions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      check: [],
      headers: [
        { text: 'Titre', value: 'title' },
        { text: 'Description', value: 'description' },
      ],
      index: -1,
    };
  },
  computed: {
    hasUp() {
      return this.index <= 0;
    },
    hasDown() {
      return !(this.index >= 0 && this.index < this.questions.length - 1);
    },
  },
  methods: {
    handleClick(item) {
      this.$emit('newQuestion', item);
    },
    newQuestion() {
      this.$emit('newQuestion', {
        title: '',
        description: '',
        help: '',
        type: 0,
        qorder: this.questions.length,
        visible: true,
      });
    },
    selected(item) {
      this.index = item.value ? this.questions.indexOf(item.item) : -1;
    },
    async up() {
      if (this.index !== -1) {
        const questionToDown = this.questions[this.index - 1];
        const questionToUp = this.questions[this.index];
        questionToDown.qorder = this.index;
        questionToUp.qorder = this.index - 1;

        await this.$store.dispatch(
          'question/edit',
          JSON.parse(JSON.stringify(questionToDown)),
        );
        await this.$store.dispatch(
          'question/edit',
          JSON.parse(JSON.stringify(questionToUp)),
        );
        await this.$emit('refreshQuestion');

        this.index -= 1;
      }
    },
    async down() {
      if (this.index !== -1) {
        const questionToDown = this.questions[this.index];
        const questionToUp = this.questions[this.index + 1];
        questionToDown.qorder = this.index + 1;
        questionToUp.qorder = this.index;

        await this.$store.dispatch(
          'question/edit',
          JSON.parse(JSON.stringify(questionToDown)),
        );
        await this.$store.dispatch(
          'question/edit',
          JSON.parse(JSON.stringify(questionToUp)),
        );
        this.$emit('refreshQuestion');

        this.index += 1;
      }
    },
  },
};
</script>

<style>
.v-data-table-header {
  background-color: #dcdcdc;
}
</style>
